import { DragDropModule } from '@angular/cdk/drag-drop';

import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { FormatComponent } from 'src/app/shared/base-components/format-component';

@Component({
  selector: 'app-release-notes-intro-modal',
  templateUrl: './release-notes-intro-modal.component.html',
  styleUrls: ['./release-notes-intro-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, TranslatePipe, DragDropModule],
})
export class ReleaseNotesIntroModalComponent extends FormatComponent {
  constructor(public dialogRef: MatDialogRef<ReleaseNotesIntroModalComponent>) {
    super();
  }

  openReleaseNotes(): void {
    this.dialogRef.close(true);
  }
}
